function toTitleCase(val) {
  const str = String(val);
  return str[0]?.toUpperCase() + str.slice(1).toLowerCase() || str;
}

export { toTitleCase };
